<!--<div class="row" *ngFor="let dt of PublicRecordData$ | async">-->
<div class="row" *ngIf="PublicRecord$ | async as pr">
    <div class="col-lg-12 col-sm-12" style="padding:10px">
        <!--<div class="row text-center">
        <div class="col-12" style="padding:0">
            <h1 class="text-center">{{dt.reportName}}</h1>
        </div>
    </div>-->

        <div class="row">

            <!--Owner Information-->
            <div class="col-lg-6 col-12">
                <h2>Owner Information</h2>
                <table style="width:100%;">
                    <tr>
                        <td class="label">Owner Names</td>
                        <td *ngIf="pr.result.ownerNames">{{pr.result.ownerNames}}</td>
                    </tr>
                    <tr>
                        <td class="label">Mailing Address</td>
                        <td>
                            {{pr.result.mailingAddressStreet}} {{pr.result.mailingAddressCity}}
                            {{pr.result.mailingAddressState}} {{pr.result.mailingAddressZip}}
                        </td>
                    </tr>
                    <tr>
                        <td class="label">County</td>
                        <td>{{pr.result.mailingAddressCounty}}</td>
                    </tr>
                </table>
            </div>

            <!--Subject Property-->
            <div class="col-lg-6 col-12">
                <h2>Subject Property</h2>
                <table style="width:100%;">
                    <tr>
                        <td class="label">Property Id</td>
                        <td>{{pr.result.publicRecordPropertyId}}</td>
                    </tr>
                    <tr>
                        <td class="label">Situs Address</td>
                        <td>
                            {{pr.result.situsAddressStreet}} {{pr.result.situsAddressCity}}
                            {{pr.result.situsAddressState}} {{pr.result.situsAddressZip}}
                        </td>
                    </tr>
                    <tr>
                        <td class="label">County</td>
                        <td>{{pr.result.situsAddressCounty}}</td>
                    </tr>
                </table><br />
            </div>

            <!--Other-->
            <div class="col-12">
                <h2>Details</h2>
            </div>
            <div class="col-lg-6 col-12">
                <table style="width:100%;">
                    <tr>
                        <td class="label">Transaction Type</td>
                        <td>{{pr.result.transactionType}}</td>
                    </tr>
                    <tr>
                        <td class="label">Buyer</td>
                        <td>{{pr.result.buyerName}}</td>
                    </tr>
                    <tr>
                        <td class="label">Zoning</td>
                        <td>{{pr.result.zoning}}</td>
                    </tr>
                    <tr *ngIf="pr.result.schoolDistrict">
                        <td class="label">School District</td>
                        <td>{{pr.result.schoolDistrict}}</td>
                    </tr>
                    <tr>
                        <td class="label">Sale Price</td>
                        <td>${{pr.result.salePrice | number : '1.0-0'}}</td>
                    </tr>
                    <tr>
                        <td class="label">Tax Year</td>
                        <td>{{pr.result.taxYear}}</td>
                    </tr>
                    <tr>
                        <td class="label">Property Tax</td>
                        <td>{{pr.result.propertyTax | number : '1.0-0'}}</td>
                    </tr>
                </table><br />
            </div>

            <div class="col-lg-6 col-12">
                <table style="width:100%;">
                    <tr>
                        <td class="label">Assessed Value</td>
                        <td>${{pr.result.assessedValue | number : '1.0-0'}}</td>
                    </tr>
                    <tr>
                        <td class="label">Basement Area</td>
                        <td>{{pr.result.basementArea}}</td>
                    </tr>
                    <tr>
                        <td class="label">Neighborhood</td>
                        <td>{{pr.result.neighborhood}}</td>
                    </tr>
                    <tr>
                        <td class="label">ElementarySchool</td>
                        <td>{{pr.result.elementarySchool}}</td>
                    </tr>
                    <tr>
                        <td class="label">Middle School</td>
                        <td>{{pr.result.middleSchool}}</td>
                    </tr>
                    <tr>
                        <td class="label">High School</td>
                        <td>{{pr.result.highSchool}}</td>
                    </tr>
                    <tr>
                        <td class="label">Buyer Borrower</td>
                        <td>{{pr.result.buyerBorrower}}</td>
                    </tr>
                    <tr>
                        <td class="label">Date Created</td>
                        <td>{{pr.result.createdTimestamp | date: 'MM-dd-yy'}}</td>
                    </tr>
                </table><br />
            </div>

        </div>

        <!--Transactions-->
        <ng-container *ngIf="pr.result.publicRecordLienResults as lienResults">
            <div class="row">
                <div class="col-12">
                    <h2>Liens</h2>
                </div>
                <div class="col-lg-6 col-12" *ngFor="let lien of lienResults">
                    <mat-card>
                        <mat-card-subtitle>

                            <table style="width:100%;">
                                <tr>
                                    <td class="label">Date</td>
                                    <td> {{lien.transactionDate | date: 'MM-dd-yy'}}</td>
                                </tr>
                                <tr>
                                    <td class="label">Lender</td>
                                    <td> {{lien.lender}}</td>
                                </tr>
                                <tr>
                                    <td class="label">Term</td>
                                    <td> {{lien.mortgageTerm}}</td>
                                </tr>
                                <tr>
                                    <td class="label">Rate</td>
                                    <td> {{lien.mortgageRate}}<span *ngIf="lien.mortgageRate">%</span></td>
                                </tr>
                                <tr>
                                    <td class="label">Loan Amount</td>
                                    <td>${{lien.loanAmount | number : '1.0-0'}}</td>
                                </tr>
                                <tr>
                                    <td class="label">Term (months)</td>
                                    <td> {{lien.loanTermMonths}}</td>
                                </tr>
                                <tr>
                                    <td class="label">Lien Position</td>
                                    <td> {{lien.lienPosition}}</td>
                                </tr>
                                <!--                                <tr class="label"><td>createdTimestamp</td><td> {{lien.createdTimestamp}}</td></tr>-->
                                <tr>
                                    <td class="label">Loan Type</td>
                                    <td> {{lien.mortgageLoanType}}</td>
                                </tr>
                            </table>
                            <ng-container *ngIf="ShowMakeCurrentButton">
                                <div class="Vert-15"></div>

                                <div class="text-center" *ngIf="isOwnedProperty">
                                    <button type="button" class="btn btn-secondary" [disabled]="IsLoading$ | async"
                                        (click)="makeAsCurrentLoan(lien, pr)">
                                        Make this the current loan
                                    </button>
                                </div>

                            </ng-container>

                        </mat-card-subtitle>
                    </mat-card>
                </div>
            </div>
        </ng-container>



    </div>
</div>
<div class="row text-center" *ngIf="Status$ | async as st">

    <div class="col-12" style="padding:0">
        <h1 class="standOutText text-center" *ngIf="st.statusDescription">{{st.statusDescription}}</h1>
        <h1 class="standOutText text-center" *ngIf="st.name">{{st.name}}</h1>
    </div>
</div>